import React from 'react'
import styles from './ActionButtons.module.scss'
import clsx from 'clsx'
import {Button} from '../../../../common/Button/Button'
import {useUIGameEndContext} from '../../../../contexts/UIGameEndContext'
import {T} from '../../../../common/T'

export function MapReplayButton() {
    const {gameEndData, onClickStatsOrReplay} = useUIGameEndContext()

    return (
        <Button
            className={clsx(styles.button)}
            onClick={onClickStatsOrReplay}
            variant='dark'>
            {gameEndData.isReplayAvailable ?
                <T id={{key: 'strings:game.endGame.cornerButton.mapWithReplay'}}/>
                : <T id={{key: 'strings:game.endGame.cornerButton.map'}}/>}
        </Button>
    )
}
